import { render, staticRenderFns } from "./jhi-item-count.vue?vue&type=template&id=54d4fc4a&"
import script from "./jhi-item-count.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-item-count.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports